import { render, staticRenderFns } from "./RunnitFieldHeader.vue?vue&type=template&id=63b4a578&scoped=true"
import script from "./RunnitFieldHeader.vue?vue&type=script&lang=ts"
export * from "./RunnitFieldHeader.vue?vue&type=script&lang=ts"
import style0 from "./RunnitFieldHeader.vue?vue&type=style&index=0&id=63b4a578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b4a578",
  null
  
)

export default component.exports